<sc-loading-spinner fitHeight [isLoading]="isLoading">
  <sc-flex vertical fitHeight stretchContent class="no-field-space">
    <div>
      <form [formGroup]="form">
        <sc-flex>
          <mat-checkbox class="spaceBehind" formControlName="showAllData" name="showAllData">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export.filter.showAllData"></sc-dictionary-label>
          </mat-checkbox>
          <sc-content-spacer></sc-content-spacer>
          <mat-form-field appearance="fill" class="spaceBehind date-field">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export.filter.from"></sc-dictionary-label>
            </mat-label>
            <input matInput formControlName="dateFrom" [matDatepicker]="picker1" type="date-local">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <sc-content-spacer></sc-content-spacer>
          <mat-form-field appearance="fill" class="spaceBehind date-field">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export.filter.to"></sc-dictionary-label>
            </mat-label>
            <input matInput formControlName="dateUntil" [matDatepicker]="picker2" type="date-local">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </sc-flex>
        <sc-content-spacer vertical></sc-content-spacer>
        <sc-flex>
          <app-structure-node-selection class="spaceBehind"
            (selectedStructureChanged)="onSelectedStructureChanged($event)" [selectedNode]="selectedStructureNode">
          </app-structure-node-selection>
          <sc-content-spacer></sc-content-spacer>
          <mat-form-field appearance="fill" class="extended-width spaceBehind">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export.filter.content"></sc-dictionary-label>
            </mat-label>
            <input matInput formControlName="query">
          </mat-form-field>
          <sc-content-spacer></sc-content-spacer>
          <sc-button dictionaryKey="tmc-visit.common.action.show" (click)="updateList()" [disabled]="isUpdateListDisabled()" button class="spaceBehind"></sc-button>
          <sc-content-spacer></sc-content-spacer>
          <mat-form-field appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export.export-type"></sc-dictionary-label>
            </mat-label>
            <mat-select formControlName="reportDefinition" [value]="selectedReport">
              @for (o of availableReports; track o) {
                <mat-option [value]="o" select>
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export.export-type.{{o.type}}"></sc-dictionary-label>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <sc-content-spacer></sc-content-spacer>
          <sc-button dictionaryKey="tmc-visit.common.action.export" (click)="createExcel()" [disabled]="isCreateDisabled()" primary
          class="spaceBehind"></sc-button>
        </sc-flex>
      </form>
    </div>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-flex-fitting-content vertical>
      <sc-content-area fitHeight>
        <sc-scroll-pane>
          <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="hint">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let transport"> <i (click)="showTransportDetails(transport)"
              class="station-details-button fa-light fa-info-circle"></i> </td>
            </ng-container>
            <ng-container matColumnDef="registrationDate">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.registration-date"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.registrationDate}} </td>
            </ng-container>
            <ng-container matColumnDef="hasTimeSlot">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.has-timeframe"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.hasTimeSlot}} </td>
            </ng-container>
            <ng-container matColumnDef="timeSlotPlannedStart">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.planning-date"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.timeSlotPlannedStart}} </td>
            </ng-container>
            <ng-container matColumnDef="timeSlotDelay">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.time-slot-delay"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.timeSlotDelay}} </td>
            </ng-container>
            <ng-container matColumnDef="processingTime">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.processing-time"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.processingTime}} </td>
            </ng-container>
            <ng-container matColumnDef="waitingTime">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.waiting-time"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.waitingTime}} </td>
            </ng-container>
            <ng-container matColumnDef="wasDeleted">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.was-deleted"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.wasDeleted}} </td>
            </ng-container>
            <ng-container matColumnDef="deletionCause">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.cancellation-cause"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.deletionCause}} </td>
            </ng-container>
            <ng-container matColumnDef="wasPaused">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.was-paused"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.wasPaused}} </td>
            </ng-container>
            <ng-container matColumnDef="totalTimePaused">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.total-time-paused"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.totalTimePaused}} </td>
            </ng-container>
            <ng-container matColumnDef="maxAllowedProcessingTime">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.planned-processing-duration"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.maxAllowedProcessingTime}} </td>
            </ng-container>
            <ng-container matColumnDef="carrier">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.carrier"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.carrier}} </td>
            </ng-container>
            <ng-container matColumnDef="string1">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.string-1"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.string1}} </td>
            </ng-container>
            <ng-container matColumnDef="string2">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.string-2"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.string2}} </td>
            </ng-container>
            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.phone"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.phone}} </td>
            </ng-container>
            <ng-container matColumnDef="transportStatus">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.transport-status"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.transportStatus}} </td>
            </ng-container>
            <ng-container matColumnDef="processingPositionsCount">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.processing-positions-count"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.processingPositionsCount}} </td>
            </ng-container>
            <ng-container matColumnDef="messagingType">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.messaging-type"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.activeMessagingChannels}} </td>
            </ng-container>
            <ng-container matColumnDef="smartphoneLent">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.smartphone-lent"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.smartphoneLent}} </td>
            </ng-container>
            <ng-container matColumnDef="transportOptionMarks">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.options"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.transportOptionMarks}} </td>
            </ng-container>
            <ng-container matColumnDef="cargoOfRoutingPositions">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.cargo"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.cargoOfRoutingPositions}} </td>
            </ng-container>
            <ng-container matColumnDef="processingStart">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.start"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.processingStart}} </td>
            </ng-container>
            <ng-container matColumnDef="planningDate">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.planning-date"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.planningDate}} </td>
            </ng-container>
            <ng-container matColumnDef="planningType">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.planning-type"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.planningType}} </td>
            </ng-container>
            <ng-container matColumnDef="preloading">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.preloading"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.preloading}} </td>
            </ng-container>
            <ng-container matColumnDef="delayedLeave">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.delayed-leave"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.delayedLeave}} </td>
            </ng-container>
            <ng-container matColumnDef="numberPlate">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.numberplate"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.numberPlate}} </td>
            </ng-container>
            <ng-container matColumnDef="trailerNumberPlate">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.trailer-number-plate"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.trailerNumberPlate}} </td>
            </ng-container>
            <ng-container matColumnDef="entrance">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.entrance-date"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.entrance}} </td>
            </ng-container>
            <ng-container matColumnDef="leave">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.leaveDate"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.leave}} </td>
            </ng-container>
            <ng-container matColumnDef="orderReference">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.order-reference"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.orderReference}} </td>
            </ng-container>
            <ng-container matColumnDef="hide">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export.table.column.hide"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let transport">
                <mat-checkbox (change)="toggleIgnore(transport)" [(ngModel)]="transport.ignore"></mat-checkbox>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
            <tr mat-row *matRowDef="let transport; columns: columnsToDisplay"></tr>
          </table>
        </sc-scroll-pane>
      </sc-content-area>
    </sc-flex-fitting-content>
  </sc-flex>
</sc-loading-spinner>
